import { UserCog } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ImpersonationBanner() {
  const { user } = useAuth();
  if (!user?.impersonated_by) return null;
  const exit = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    window.location.assign("/login");
  };
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[70] bg-amber-500 text-slate-900 text-sm font-semibold px-4 py-2 flex items-center justify-center gap-3">
      <span className="flex items-center gap-2"><UserCog size={16} /> Viewing as {user.name || user.email}</span>
      <button onClick={exit} data-testid="impersonation-exit" className="rounded-full bg-slate-900 text-white px-3 py-1 text-xs font-semibold hover:bg-slate-800">Exit to admin login</button>
    </div>
  );
}
